import React from "react";
import { Link } from "react-router-dom";
import { isEmpty } from "lodash";

export const displayLink = r =>
  r.serial_number === "Various" || isEmpty(r.inventory_link_id) ? (
    r.serial_number || r.expected_serial_number
  ) : (
    <Link to={`/inventories/${r.inventory_link_id}`}>{r.serial_number}</Link>
  );



// WEBPACK FOOTER //
// ./app/modules/PurchaseOrders/helpers.jsx